import _ from "lodash";
import React from "react";
import { compose } from "lib/apolloClient";
import classes from "./CheckListEdit.scss";
import { connect } from "react-redux";
import I18nHOC from "UIComponents/I18nHOC";
import { Button, Tooltip, IconButton } from "@toddle-edu/ds-web";
import {
  AddOutlined,
  SinglePointRubricOutlined,
  AssessmentApplicableOutlined,
  ConfigureColumnsOutlined,
} from "@toddle-edu/ds-icons";

import {
  createChecklistItem,
  createChecklistOptionItem,
  deleteChecklistOption,
  deleteChecklistItem,
  writeChecklistElementLocal,
} from "Checklist/modules/ChecklistModule";

import { saveAssessmentToolUpdateStatusInRedux } from "Assessments/modules/AssessmentModule";

import { updateField } from "modules/FieldUpdateThunks";
import CheckListEditRow from "./CheckListEditRow";

const MIN_OPTION_COUNT = 1;
const MAX_OPTION_COUNT = 4;

class CheckListComp extends React.PureComponent {
  constructor(props) {
    super(props);
    if (props.customRef) {
      props.customRef(this);
    }
    this.state = { inFocusColumn: null, inFocusRow: null };
    this.focusedCell = null;
    this.cellRefs = {};
  }

  onColumnFocus = id => {
    this.setState({ inFocusColumn: id });
  };

  onRowFocus = id => {
    this.setState({ inFocusRow: id });
  };

  blur = () => {
    if (this.focusedCell && this.cellRefs[this.focusedCell]) {
      this.cellRefs[this.focusedCell].blur();
    }
  };

  setCellRef = ({ key, ref }) => {
    this.cellRefs[key] = ref;
  };

  setFocusedCell = key => {
    this.focusedCell = key;
  };

  render() {
    const {
      checklistItems,
      checklistOptionItems,
      onOptionDeleteClick,
      onItemDeleteClick,
      writeCheckListElement,
      toolStyles = {},
      showHoverState,
      writeChecklistElementLocal,
      assignmentId,
      saveAssessmentToolUpdateStatusInRedux,
    } = this.props;

    const { checkListContainerStyle } = toolStyles;

    const { inFocusColumn, inFocusRow } = this.state;

    return (
      <div
        onBlur={() => this.setState({ inFocusColumn: null, inFocusRow: null })}
        className={classes.checkListContainer}
        style={checkListContainerStyle}
      >
        {_.map(checklistItems, (item, index) => {
          return (
            <CheckListEditRow
              onColumnFocus={this.onColumnFocus}
              onRowFocus={this.onRowFocus}
              focusedColumn={inFocusColumn}
              setCellRef={this.setCellRef}
              setFocusedCell={this.setFocusedCell}
              focusedRow={inFocusRow}
              key={item.id}
              item={item}
              label={item.label}
              options={checklistOptionItems}
              index={index}
              minOptionCount={MIN_OPTION_COUNT}
              onOptionDeleteClick={onOptionDeleteClick}
              onItemDeleteClick={onItemDeleteClick}
              id={item.id}
              writeCheckListElement={writeCheckListElement}
              showDeleteCriteriaButton={_.size(checklistItems) > 1}
              toolStyles={toolStyles}
              showHoverState={showHoverState}
              writeChecklistElementLocal={writeChecklistElementLocal}
              assignmentId={assignmentId}
              saveAssessmentToolUpdateStatusInRedux={
                saveAssessmentToolUpdateStatusInRedux
              }
            />
          );
        })}
      </div>
    );
  }
}
class CheckListEdit extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { showToolList: false };
    if (props.customRef) {
      props.customRef(this);
    }
    this.checklistComp = null;

    this.debouncedWriteChecklistElementLocal = _.debounce(
      props.writeChecklistElementLocal,
      1000
    );
  }

  blur = () => {
    if (this.checklistComp) {
      this.checklistComp.blur();
    }
  };

  onCopyTool = params => {
    const { onCopyTool } = this.props;
    onCopyTool(params);
    this.setState({ showToolList: false });
  };
  writeCheckListElement = ({ id, type, label, elementDetails }) => {
    const { updateField, portalType } = this.props;

    this.debouncedWriteChecklistElementLocal({
      id,
      type,
      label,
      elementDetails,
    });

    updateField({
      key: id,
      params: {
        id,
        type,
        label,
        portalType,
      },
      type: "CHECKLIST_ELEMENT",
    });
  };

  createEmptyCheckListItem = () => {
    const {
      createChecklistItem,
      setScrollToBottom,
      checklist: { id: checklistId },
      portalType,
    } = this.props;
    createChecklistItem({ label: "", checklistId, portalType });
    if (setScrollToBottom) {
      setTimeout(setScrollToBottom);
    }
  };

  createEmptyCheckListOptionItem = () => {
    const {
      createChecklistOptionItem,
      checklist: { id: checklistId },
      portalType,
    } = this.props;
    createChecklistOptionItem({ label: "", checklistId, portalType });
  };

  onOptionDeleteClick = optionId => {
    const {
      deleteChecklistOption,
      checklist: { id: checklistId },
      portalType,
    } = this.props;

    deleteChecklistOption({ checklistId, optionId, portalType });
  };

  onItemDeleteClick = item => {
    const {
      deleteChecklistItem,
      checklist: { id: checklistId, checklistItems },
      portalType,
    } = this.props;
    if (checklistItems.length == 1) {
      this.writeCheckListElement({
        id: item.id,
        type: "CHECKLIST_ITEM",
        label: "",
        elementDetails: item,
      });
    } else {
      deleteChecklistItem({ checklistId, itemId: item.id, portalType });
    }
  };

  shouldOptionAddButtonDisabled = () => {
    const { checklistOptionItems } = this.props.checklist || {};

    return (
      (!!checklistOptionItems &&
        checklistOptionItems.length >= MAX_OPTION_COUNT) ||
      _.includes(_.last(checklistOptionItems)?.id, "NEW")
    );
  };

  renderActionButtons = () => {
    const {
      t,
      checklist,
      onClickToolSave,
      showSaveTemplateButton,
      showActionButtons = true,
      actionButtonsUIType = "BUTTON",
      toolStyles = {},
    } = this.props;

    if (!showActionButtons) return null;

    const { checklistOptionItems } = checklist || {};

    const isOptionAddButtonDisabled = this.shouldOptionAddButtonDisabled();
    const { checklistItems } = checklist || {};
    const { borderLeftContainerStyle } = toolStyles;
    const disableAddCriteriaButton =
      _.includes(_.last(checklistOptionItems)?.id, "NEW") ||
      _.includes(_.last(checklistItems)?.id, "NEW");
    const disableAddOptionsButton =
      disableAddCriteriaButton || isOptionAddButtonDisabled;

    const renderButtons = () => {
      switch (actionButtonsUIType) {
        case "BUTTON": {
          return (
            <>
              <div
                className={classes.borderLeftContainer}
                style={borderLeftContainerStyle}
              >
                <Button
                  variant={"outlined-subtle"}
                  size={"medium"}
                  onClick={this.createEmptyCheckListItem}
                  icon={<AddOutlined />}
                  disabled={disableAddCriteriaButton}
                >
                  {t("common:add_with_label", {
                    label: t("common:lowercase", {
                      text: t("common:criteria"),
                    }),
                  })}
                </Button>
                <Button
                  variant={"outlined-subtle"}
                  size={"medium"}
                  onClick={this.createEmptyCheckListOptionItem}
                  icon={<AddOutlined />}
                  disabled={disableAddOptionsButton}
                >
                  {t("common:add_with_label", {
                    label: t("common:lowercase", {
                      text: t("common:option"),
                    }),
                  })}
                </Button>
              </div>

              {showSaveTemplateButton ? (
                <Button
                  variant={"outlined-subtle"}
                  size={"medium"}
                  onClick={onClickToolSave}
                >
                  {t("classRoom:save_as_template")}
                </Button>
              ) : null}
            </>
          );
        }
        case "ICON_BUTTON": {
          return (
            <>
              <div
                className={classes.borderLeftContainer}
                style={borderLeftContainerStyle}
              >
                <Tooltip
                  placement={"top"}
                  tooltip={t("common:add_with_label", {
                    label: t("common:lowercase", {
                      text: t("common:criteria"),
                    }),
                  })}
                >
                  <IconButton
                    icon={<SinglePointRubricOutlined />}
                    variant={"plain"}
                    size={"small"}
                    disabled={disableAddCriteriaButton}
                    onClick={this.createEmptyCheckListItem}
                  />
                </Tooltip>

                <Tooltip
                  placement={"top"}
                  tooltip={t("common:add_with_label", {
                    label: t("common:lowercase", {
                      text: t("common:option"),
                    }),
                  })}
                >
                  <IconButton
                    icon={<ConfigureColumnsOutlined />}
                    variant={"plain"}
                    size={"small"}
                    disabled={disableAddOptionsButton}
                    onClick={this.createEmptyCheckListOptionItem}
                  />
                </Tooltip>
              </div>

              {showSaveTemplateButton ? (
                <Tooltip
                  placement={"top"}
                  tooltip={t("classRoom:save_as_template")}
                >
                  <IconButton
                    icon={<AssessmentApplicableOutlined />}
                    variant={"plain"}
                    size={"small"}
                    onClick={onClickToolSave}
                  />
                </Tooltip>
              ) : null}
            </>
          );
        }
      }
    };

    return <div className={classes.buttonContainer}>{renderButtons()}</div>;
  };

  render() {
    const {
      t,
      checklist,
      containerStyle,
      toolStyles = {},
      showHoverState = false,
      writeChecklistElementLocal,
      assignmentId,
      saveAssessmentToolUpdateStatusInRedux,
    } = this.props;

    if (!checklist) {
      return (
        <div className={classes.emptyText}>
          {t("common:no_checklist_defined")}
        </div>
      );
    }

    const { checklistItems, checklistOptionItems } = checklist || {};

    return (
      <div className={classes.container} style={containerStyle}>
        <CheckListComp
          ref={ref => (this.checklistComp = ref)}
          createEmptyCheckListItem={this.createEmptyCheckListItem}
          checklistItems={checklistItems}
          checklistOptionItems={checklistOptionItems}
          onOptionDeleteClick={this.onOptionDeleteClick}
          onItemDeleteClick={this.onItemDeleteClick}
          writeCheckListElement={this.writeCheckListElement}
          toolStyles={toolStyles}
          showHoverState={showHoverState}
          writeChecklistElementLocal={writeChecklistElementLocal}
          assignmentId={assignmentId}
          saveAssessmentToolUpdateStatusInRedux={
            saveAssessmentToolUpdateStatusInRedux
          }
        />

        {this.renderActionButtons()}
      </div>
    );
  }
}

const mapActionCreators = {
  createChecklistItem,
  createChecklistOptionItem,
  deleteChecklistOption,
  deleteChecklistItem,
  writeChecklistElementLocal,
  updateField,
  saveAssessmentToolUpdateStatusInRedux,
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

CheckListEdit.defaultProps = {
  showSaveTemplateButton: true,
};

export default compose(
  I18nHOC({ resource: "common" }),
  connect(mapStateToProps, mapActionCreators)
)(CheckListEdit);
